import BaseStickySidebar from "@core/components/base-sticky-sidebar/base-sticky-sidebar";
import $ from 'jquery';
import uniqueId from 'lodash/uniqueId';
import whatInput from 'what-input';
import Utils from "@core/base/scripts/utils/utils";
import BackToTop from "../back-to-top/back-to-top";
import A11yUtils from "@core/base/scripts/utils/a11y-utils";
import ScrollSpy from 'bootstrap/js/dist/scrollspy.js';


export default class ArticleStickyBar extends BaseStickySidebar {

  constructor(container) {
    super(container);
    this.autoHideBar=false;
    this.filled = false;
    this.CLASSES = {
      list: 'article-sticky-bar__list',
      item: 'article-sticky-bar__list__item',
      itemSelected: 'article-sticky-bar__list__item--selected'
    };
    this.CONTROLS_ID = 'article-sticky-bar-list';
    this.$list = null;
    this.$h2s = null;
    this.$items = null;
    this.$lastSelectedItem = null;
    this.$list = null;
    this.scrollHandler = null;
    this.scrollSpy=null;
  }

  init(isOnResize=false) {
    super.init();
    this.$collapseBtn = $('.article-sticky-bar__nav__header');
    this.searchH2OnPage();

    const backToTop = new BackToTop();
    backToTop.init();

    if (Utils.isTablet) {
      this.buildCollapseBtn();
    }

    this.listenEvents();

    this.scrollSpy=new ScrollSpy(
      $('body')[0],
      {
        offset: 300,
        target: '.article-sticky-bar__list'
      }
    );
    this.onClick();

    if(!isOnResize){
      this.onPageLoad();
    }
    // RT #145753
    this.hideStickyBarIfEmpty();
  }


  hideStickyBarIfEmpty(){
    
    const stickyBars = document.getElementsByClassName('article-sticky-bar__nav');

    for(const stickyBar of stickyBars){  
      const rubrics = stickyBar.querySelectorAll('ul');
      for(const rubric of rubrics){
        stickyBar.querySelector('.article-sticky-bar__nav__header').style.display = rubric.innerHTML.trim() == "" ? 'none' : 'flex';
      }
    }
    
  }

  listenEvents() {
    $(document).on('refreshStickyBar', () => {
      this.destroy();
      this.init();
    });
  }

  searchH2OnPage() {
    this.$list = $(`.${this.CLASSES.list}`, this.container);
    this.$h2s = this.container.closest('.container').find('h2');
    this._offsets = [];
    if (this.$h2s.length > 0 && !this.filled) {
      this.$h2s.each((i, e) => {
        const $elt = $(e);
        const id = uniqueId('h2_');
        $elt.attr('id', id);
        this.$list.append(this.getMarkup(id, $elt.text(), i === 0));
        //
        this._offsets.push($elt.offset().top);
      });
    }
    this.$items = $(`.${this.CLASSES.item}`);
    this.filled = true;
  }

  onPageLoad(){
    console.log("onPageLoad");
    const hash = window.location.hash.substr(1);
    if(hash){
      this.goToTitle(hash);
    }
    
  }

  onClick() {
    this.$items.on('click', e => {
      e.preventDefault();
      if (this.$lastSelectedItem) {
        this.$lastSelectedItem.removeClass(`${this.CLASSES.itemSelected}`);
      }
      this.$lastSelectedItem = $(e.currentTarget);

      this.goToTitle(this.$lastSelectedItem.attr('href').split('#')[1]);
    });
  }

  goToTitle(id) {
    $(`#${id}`).attr('tabindex', '-1');
    Utils.goToHash(id, () => {
      if (whatInput.ask() === 'keyboard') {
        $(`#${id}`) .focus();
      }
      this.scrollSpy.refresh();
    });
  }

  buildCollapseBtn() {
    this.$collapseBtn
      .off()
      .attr('role', 'button')
      .attr(A11yUtils.ARIA.expanded, false)
      .attr(A11yUtils.ARIA.controls, this.CONTROLS_ID)
      .attr('tabindex', 0);

    this.$collapseBtn.on('keydown', e => {
      if (e.which === A11yUtils.keyboard.space || e.which === A11yUtils.keyboard.enter) {
        this.collapse();
        return false;
      }
      return true;
    });

    this.$collapseBtn.on('click', e => {
      e.preventDefault();
      this.collapse();
    });
  }


  collapse() {
    this.$list.slideToggle(() => {
      const expanded = this.$collapseBtn.attr(A11yUtils.ARIA.expanded) === 'true';
      if (!expanded) {
        this.$list.find(A11yUtils.FOCUSABLES)[0].focus();

        this.$collapseBtn.attr(A11yUtils.ARIA.expanded, true);
      } else {
        this.$collapseBtn.focus();
        this.$collapseBtn.attr(A11yUtils.ARIA.expanded, false);
      }
    });
  }


  getMarkup(id, title) {
    return $(`
    <li>
      <a class="${this.CLASSES.item} nav-link" href="#${id}">
        ${title}
      </a>
    </li>`);
  }


  destroy() {
    super.destroy();
    if (this.$collapseBtn && this.$list) {
      this.$collapseBtn
        .off()
        .removeAttr('role')
        .removeAttr(A11yUtils.ARIA.expanded)
        .removeAttr(A11yUtils.ARIA.controls)
        .removeAttr('tabindex');
      this.$list.removeAttr('style');
    }
  }

}
